import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { GenericTableComponent } from "../../../../shared/components/generic-table/generic-table.component";
import { TableFiltersComponent } from "../../../../shared/components/generic-table/table-filters/table-filters.component";
import {
  TableHeaderWrapperComponent
} from "../../../../shared/components/generic-table/table-header-wrapper/table-header-wrapper.component";
import { TableHeader } from "../../../../models/Table/TableHeader";
import { Filter } from "../../../../models/Table/Filter";
import { Paginator } from "../../../../models/Paginator";
import { Reservation } from "../../../../models/Reservation";
import { ReservationService } from "../../../../core/services/reservations/reservation.service";
import { SortColumn } from "../../../../models/Table/SortColumn";
import { ActiveFilter } from "../../../../models/Table/ActiveFilter";
import { forkJoin, of } from "rxjs";
import { catchError } from "rxjs/operators";
import { AuthFormInputDirective } from "../../../../shared/directives/auth/auth-form-input.directive";
import { NgIf } from "@angular/common";
import { InputSwitchModule } from "primeng/inputswitch";
import { FormsModule } from "@angular/forms";
import { NgxSpinner, NgxSpinnerComponent, NgxSpinnerService } from "ngx-spinner";
import { RouterOutlet, ActivatedRoute } from "@angular/router";
import { BreadcrumbService } from "../../../../core/services/breadcrumb/breadcrumb.service";
import { VehiclesService } from "../../../../core/services/vehicles/vehicles.service";
import { StationService } from "../../../../core/services/stations/station.service";
import { ServicesService } from "../../../../core/services/services/services.service";
import { TableActions } from "../../../../models/Table/TableActions";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { ConfirmationService } from "primeng/api";
import { ToastrService } from "ngx-toastr";
import { FrontService } from "../../../../core/services/front/front.service";
import { ReservationGesService } from "../../../../core/services/reservations/reservation-ges.service";
import { DialogModule } from "primeng/dialog";
import {
  ExistingReservationCardComponent
} from "../../../front/components/existing-reservation-card/existing-reservation-card.component";
import {
  TableBulkActionsComponent
} from "../../../../shared/components/generic-table/table-bulk-actions/table-bulk-actions.component";
import { UserService } from "../../../../core/services/users/user.service";
import { AuthStateService } from "../../../../core/services/auth/auth-state.service";
import { State } from "../../../../models/State";
import { User } from '../../../../models/User';
import { Router } from '@angular/router';
import { environment } from '../../../../../environments/environment';
import { PaymentMethodsService } from '../../../../core/services/payment-methods/payment-methods.service';
import { FuelService } from '../../../../core/services/fuels/fuel.service';
@Component({
  selector: 'app-calendar',
  standalone: true,
  imports: [
    AuthFormInputDirective,
    NgIf,
    InputSwitchModule,
    FormsModule,
    NgxSpinnerComponent,
    RouterOutlet,
    TableHeaderWrapperComponent,
    TableFiltersComponent,
    GenericTableComponent,
    DialogModule,
    ExistingReservationCardComponent,
    TableBulkActionsComponent,
    // ConfirmDialogModule
  ],
  // providers: [ConfirmationService],
  templateUrl: './calendar.component.html',
  styleUrl: './calendar.component.css'
})
export class CalendarComponent {

  perPage: number = 50;
  loading = false;
  loadingFilters = false;
  displayEditDialog: boolean = false;
  selectedReservation?: Reservation;
  editReservation: boolean = true;
  currentUser: User | null;



  tableActions: TableActions[] = [
    {
      icon: '<svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1.5"  stroke-linecap="round"  stroke-linejoin="round"  class="w-5"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" /><path d="M10 10l4 4m0 -4l-4 4" /></svg>',
      name: 'Cancelar',
      key: 'cancel',
      color: '#FF0000',
      confirm: true,
      confirmTitle: 'Cancelar reserva',
      confirmSubTitle: '¿Estás seguro de que deseas cancelar esta reserva?',
    },
    {
      icon: '<svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="w-5 h-5"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" /><path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" /><path d="M16 5l3 3" /></svg>',
      name: 'Editar',
      key: 'edit',
      color: '#FF8A4C',
      confirm: false,
    },
    {
      icon: '<svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-download"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2" /><path d="M7 11l5 5l5 -5" /><path d="M12 4l0 12" /></svg>',
      name: 'Descargar',
      key: 'download',
      color: '#168FFB',
      confirm: false,
    }
  ];

  tableFilters: Filter[] = []

  displayNames: { [key: string]: string } = {
    date: 'Fecha',
    registration_number: 'Término',
    station_id: 'Estación',
    service_id: 'Servicio',
    payment_method_id: 'Método de pago',
    vehicle_id: 'Vehiculo',
    fuel_id: 'Combustible',
    user_id: 'Operadora',
    professional_id: 'Profesional',
    state: 'Estado',
    'registration_number|phone|ip': "Término"
  };

  today: Date = new Date();
  futureDate: Date = new Date();

  reservations: Paginator<Reservation> | null = null;
  reservationsCsv: Reservation[] | null = null;


  tableHeaders: TableHeader[] = [
    {
      name: 'ID',
      active: true,
      td_type: 'text',
      td_key: 'id',
      sort: false,
    },
    {
      name: 'MATRÍCULA',
      active: true,
      td_type: 'text',
      td_key: 'registration_number',
      sort: false,
    },
    {
      name: 'FECHA CITA',
      td_type: 'date',
      active: true,
      td_key: 'date',
      format: 'dd/MM/yyyy',
      sort: true,
    },
    {
      name: 'HORA',
      td_type: 'text',
      td_key: 'hour',
      active: true,
      table: 'hours',
      td_sub_key: 'hour',
      sort: true,
    },
    {
      name: 'TELÉFONO',
      active: true,
      td_type: 'text',
      td_key: 'phone',
      sort: false,
    },
    {
      name: 'SERVICIO',
      td_type: 'text',
      active: true,
      td_key: 'service',
      table: 'services',
      td_sub_key: 'name',
      sort: false,
    },
    {
      name: 'TIPO VEHÍCULO',
      td_type: 'text',
      td_key: 'vehicle',
      active: true,
      table: 'vehicles',
      td_sub_key: 'name',
      sort: true,
    },
    {
      name: 'CENTRO ITV',
      td_type: 'text',
      td_key: 'station',
      active: true,
      table: 'stations',
      td_sub_key: 'name',
      sort: true,
    },
    {
      name: 'MÉTODO PAGO',
      td_type: 'text',
      td_key: 'payment_method',
      active: true,
      td_sub_key: 'name',
      sort: false,
    },
    {
      name: 'ESTADO',
      active: true,
      td_type: 'boolean-click',
      td_key: 'state',
      sort: false,
    },
    {
      name: 'OPERADOR',
      td_type: 'text',
      td_key: 'user',
      active: false,
      table: 'users',
      td_sub_key: 'name',
      default: 'WEB',
      sort: false,
    },
    {
      name: 'IP',
      td_type: 'text',
      td_key: 'ip',
      active: true,
      default: '-',
      sort: true,
    },
    {
      name: 'DISPOSITIVO',
      td_type: 'text',
      td_key: 'device',
      active: false,
      default: '-',
      sort: false,
    },
    {
      name: 'PROFESIONAL',
      td_type: 'text',
      td_key: 'professional',
      active: true,
      table: 'users',
      td_sub_key: 'name',
      default: '-',
      sort: false,
    },
    {
      name: 'INTERNA',
      td_type: 'boolean',
      td_key: 'locked',
      active: false,
      sort: false,
    },
    {
      name: 'FECHA CREACIÓN',
      td_type: 'date',
      active: false,
      td_key: 'created_at',
      format: 'dd/MM/yyyy HH:mm',
      sort: true,
    },
    {
      name: 'FECHA MODIFCACIÓN',
      td_type: 'date',
      active: false,
      td_key: 'updated_at',
      format: 'dd/MM/yyyy HH:mm',
      sort: true,
    }
  ]


  constructor(private reservationService: ReservationService, private breadcrumbService: BreadcrumbService,
    private vehiclesService: VehiclesService, 
    private stationService: StationService,
    private serviceService: ServicesService,
    private paymentMethodsService: PaymentMethodsService,
    private toastr: ToastrService,
    private authStateService: AuthStateService,
    private reservationGesService: ReservationGesService, 
    private userService: UserService,
    private spinner: NgxSpinnerService,
    private fuelService: FuelService,
    private route: ActivatedRoute,
    private router: Router,
    private cdr: ChangeDetectorRef) {


    this.currentUser = this.authStateService.currentUserValue;
    this.loadFiltersAndSortsFromLocalStorage()
    this.loadReservations();
    this.loadElements();
    this.breadcrumbService.setBreadcrumb({
      display_name: 'Agenda',
      items: [{
        name: 'Listado',
      }]
    })

    if (!this.authStateService.isNotProfessional()) {
      this.tableHeaders = [
        {
          name: 'MATRÍCULA',
          active: true,
          td_type: 'text',
          td_key: 'registration_number',
          sort: false,
        },
        {
          name: 'FECHA CITA',
          td_type: 'date',
          active: true,
          td_key: 'date',
          format: 'dd/MM/yyyy',
          sort: true,
        },
        {
          name: 'HORA',
          td_type: 'text',
          td_key: 'hour',
          active: true,
          table: 'hours',
          td_sub_key: 'hour',
          sort: true,
        },
        {
          name: 'CENTRO ITV',
          td_type: 'text',
          td_key: 'station',
          active: true,
          table: 'stations',
          td_sub_key: 'name',
          sort: true,
        },
        {
          name: 'ESTADO',
          active: true,
          td_type: 'boolean',
          td_key: 'state',
          sort: false,
        },
      ]
    }

  }

  sorts: SortColumn[] = [];
  filters: ActiveFilter[] = [];



  closeEditView(reservation: Reservation) {
    this.displayEditDialog = false;

    if (this.reservations?.data) {
      // Encuentra el índice de la reserva con el mismo id dentro de reservations.data
      const index = this.reservations.data.findIndex(r => r.id === reservation.id);

      // Si se encuentra la reserva, reemplázala con la nueva
      if (index !== -1) {
        this.reservations.data[index] = reservation;
      }
    }

  }

  loadFiltersAndSortsFromLocalStorage() {
    if (this.router.url.includes('agenda-diaria')) {
      this.loadFiltersFromInfoDayModal()
      this.sorts.push({ column: 'hour', order: 'asc', relationship: { "table": "hours", "column": "hour" } });
      this.sorts.push({ column: 'date', order: 'asc', relationship: null });
      localStorage.setItem('itv_reservation_sorts', JSON.stringify(this.sorts));
    
      return; 
    } else {
      localStorage.removeItem('itv_reservation_filters');
      this.filters = [];
    }

    this.sorts.push({ column: 'hour', order: 'asc', relationship: { "table": "hours", "column": "hour" } });
    this.sorts.push({ column: 'date', order: 'asc', relationship: null });
    localStorage.setItem('itv_reservation_sorts', JSON.stringify(this.sorts));

    this.futureDate = new Date(this.futureDate.setMonth(this.futureDate.getMonth() + 3));
    // Recuperar y procesar filtros
    let storedFilters = null; //localStorage.getItem('itv_reservation_filters');
    if (storedFilters) {
      const parsedFilters = JSON.parse(storedFilters) as ActiveFilter[];

      // Convertir cadenas de texto a objetos Date para filtros de fecha
      this.filters = parsedFilters.map(filter => {
        if (filter.column === 'date' && Array.isArray(filter.value)) {
          return {
            ...filter,
            value: filter.value.map((v: any) => new Date(v)) // Convertir cada valor a Date
          };
        }
        return filter;
      });
      if (!this.filters.some(f => f.parsed === 'date-arr')) {
        this.filters.push(
          {
            column: "date",
            format: "dd/MM/yyyy",
            operator: "between",
            parsed: "date-arr",
            expanded: false,
            value: this.currentUser?.profile.association ? [this.today, this.futureDate] : [this.today, this.today]
          }
        )
      }
    } else {
      this.filters.push(
        {
          column: "date",
          format: "dd/MM/yyyy",
          operator: "between",
          parsed: "date-arr",
          value: this.currentUser?.profile.association ? [this.today, this.futureDate] : [this.today, this.today]
        }
      )
    }
    // Recuperar y procesar órdenes de clasificación
    /*let storedSorts = localStorage.getItem('itv_reservation_sorts');
    if(storedSorts){
      this.sorts = JSON.parse(storedSorts) as SortColumn[];
    }*/

    let storedColumns = localStorage.getItem('itv_reservation_columns_2');
    let storedTableHeaders: TableHeader[] = [];

    // Si hay columnas almacenadas, las parseamos
    if (storedColumns) {
      storedTableHeaders = JSON.parse(storedColumns) as TableHeader[];
    }

    // Fusionar las columnas guardadas con las columnas por defecto
    // Si una columna no está guardada, la añadimos como visible por defecto
    this.tableHeaders = this.tableHeaders.map(defaultCol => {
      const storedCol = storedTableHeaders.find(col => col.td_key === defaultCol.td_key);
      return storedCol || defaultCol;  // Si no está en storedCol, usamos la columna por defecto
    });
  }

  changeColumns(tableHeaders: TableHeader[]) {
    localStorage.setItem('itv_reservation_columns_2', JSON.stringify(tableHeaders))
  }

  loadReservations() {
    this.loading = true;
    this.reservationService.list(this.sorts, this.filters, this.perPage).subscribe({
      next: data => {
        if (data.data) {
          this.reservations = data.data;
        } else {
          this.reservations = null;
        }
        this.loading = false;
      },
      error: err => {
        this.loading = false;
      },
    })

  }

  loadElements() {
    this.loadingFilters = true;
    const requests: any = {
      services: this.serviceService.list(),
      vehicles: this.vehiclesService.list(),
      stations2: this.stationService.listByState(),
      paymentMethods: this.paymentMethodsService.list(),
      fuels: this.fuelService.list().pipe(catchError(() => of({ data: [] })))
    };

    // Agregar peticiones adicionales solo si el usuario **no** es profesional
    if (this.authStateService.isNotProfessional()) {
      requests.users = this.userService.listOperadoras();
      requests.professionals = this.userService.listProfessionals();
    }

    forkJoin(requests).subscribe({
      next: (results: any) => {
        console.log(results);
        if (results.stations2.data) {
          let groupedStates: any[] = [];
          results.stations2.data.forEach((item: State) => {
            let data = {
              label: item.name,
              value: item,
              img: item.logo?.original_url ?? null,
              items: []
            }
            item.stations?.forEach(station => {
              // @ts-ignore
              data.items.push(station)
            })
            groupedStates.push(data);
          })
          this.tableFilters.push({
            key: 'date',
            type: 'date-between',
            parsed: 'date-arr',
            operator: 'between',
            placeholder: 'Fecha'
          })
          this.tableFilters.push({
            key: 'station_id',
            type: 'multiselect',
            group: true,
            operator: 'in',
            multiSelectItems: groupedStates ?? [],
            placeholder: 'Estación',
            parsed: "relationship-arr",
            relation_column: 'name',
            relation_filter_column: 'id'
          });
        }
        this.tableFilters.push({
          key: 'service_id',
          type: 'multiselect',
          operator: 'in',
          multiSelectItems: results.services.data ?? [],
          placeholder: 'Servicio',
          parsed: "relationship-arr",
          relation_column: 'name',
          relation_filter_column: 'id'
        });
        this.tableFilters.push({
          key: 'vehicle_id',
          type: 'multiselect',
          operator: 'in',
          multiSelectItems: results.vehicles.data ?? [],
          placeholder: 'Vehículo',
          parsed: "relationship-arr",
          relation_column: 'name',
          relation_filter_column: 'id'
        });
        if (results.fuels.data?.length) {
          this.tableFilters.push({
            key: 'fuel_id',
            type: 'multiselect',
            operator: 'in',
            multiSelectItems: results.fuels.data,
            placeholder: 'Combustible',
            parsed: "relationship-arr",
            relation_column: 'name',
            relation_filter_column: 'id'
          });
        }
        this.tableFilters.push({
          key: 'payment_method_id',
          type: 'multiselect',
          operator: 'in',
          multiSelectItems: results.paymentMethods.data ?? [],
          placeholder: 'Método de pago',
          parsed: "relationship-arr",
          relation_column: 'name',
          relation_filter_column: 'id'
        });
        this.tableFilters.push({
          key: 'registration_number|phone|ip',
          type: 'search',
          operator: 'like',
          placeholder: 'Buscar...'
        });

        this.tableFilters.push({
          key: 'state',
          type: 'multiselect',
          operator: 'in',
          multiSelectItems: [{ name: "Pasadas", state: 1 }, { name: "No pasadas", state: 0 }],
          placeholder: 'Estado',
          parsed: "array",
          relation_column: 'name',
          relation_filter_column: 'state'
        })

        if (results.users) {
          this.tableFilters.push({
            key: 'user_id',
            type: 'multiselect',
            operator: 'in',
            multiSelectItems: results.users.data ?? [],
            placeholder: 'Operadoras',
            parsed: "relationship-arr",
            relation_column: 'name',
            relation_filter_column: 'id'
          })
        }

        if (results.professionals) {
          this.tableFilters.push({
            key: 'professional_id',
            type: 'multiselect',
            operator: 'in',
            multiSelectItems: results.professionals.data ?? [],
            placeholder: 'Profesionales',
            parsed: "relationship-arr",
            relation_column: 'name',
            relation_filter_column: 'id'
          })
        }

        this.loadingFilters = false;
      },
      error: (error) => {
        this.loadingFilters = false;
        // Manejar errores aquí
        console.error('Error al llamar a los observables:', error);
      }
    });
  }

  onChangeSorts(sorts: SortColumn[]): void {
    this.sorts = sorts;
    localStorage.setItem('itv_reservation_sorts', JSON.stringify(this.sorts))
    this.loadReservations();
  }


  onChangeFilters(filters: ActiveFilter[]) {
    this.filters = filters;
    this.loadReservations();
  }

  onBooleanClick(data: { header: TableHeader, item: Reservation, index: number }) {
    if (this.authStateService.isNotProfessional()) {
      this.reservationService.updateState(data.item.id).subscribe({
        next: (data) => {
          if (data.data) {
          }
        },
        error: error => {
          this.toastr.error('Ha habido un error al editar la reserva.');
        }
      });
    }
  }

  // Método para eliminar la reserva del paginador
  removeReservationFromPaginator(reservationId: number): void {
    if (this.reservations && this.reservations.data) {
      this.reservations.data = this.reservations.data.filter(reservation => reservation.id !== reservationId);
    }
  }

  onClickAction(data: { action: TableActions, item: Reservation, index: number }) {

    if (data.action.key === 'cancel') {
      this.reservationGesService.cancel(data.item.id, null).subscribe({
        next: (response) => {
          if (response.success) {
            this.removeReservationFromPaginator(data.item.id);
            this.toastr.success(response.message)
          } else {
            this.toastr.error(response.message);
          }
        },
        error: (err) => {
          this.toastr.error(err.error.message);
        }
      });
    }
    if (data.action.key === 'edit') {
      this.openEditDialog(data.item);
    }
    if (data.action.key === 'download') {
      const link = document.createElement('a');
          link.href = `${environment.API_URL}/reservations/proof/${data.item.id}/${data.item.phone}/${this.getCookie('googtrans')}`;
          link.setAttribute('download', ''); // Este atributo fuerza la descarga
          link.rel = 'noopener noreferrer'; // Seguridad adicional
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
    }
  }

  getCookie(name: string) {
    const cookies = document.cookie.split("; ");
    for (let cookie of cookies) {
      let [key, value] = cookie.split("=");
      if (key === name) {
        return decodeURIComponent(value.split('/')[2]);
      }
    }
    return 'es'; // Si la cookie no existe
  }

  openEditDialog(reservation: Reservation) {
    this.selectedReservation = reservation; // Asigna la reserva seleccionada
    this.displayEditDialog = true; // Muestra el diálogo
  }


  onEditConfirm() {
    // Lógica para confirmar los cambios de edición
    this.displayEditDialog = false; // Cierra el diálogo después de confirmar
    this.toastr.success('Cambios guardados correctamente.');
  }


  bulkActions = [
    { label: 'Exportar CSV', key: 'csv' }
  ];

  // Método para eliminar elementos
  deleteItems(items: Reservation[]) {
    // Implementar la lógica para eliminar todos los elementos pasados como argumento
  }

  bulkActionClick(key: string) {
    if (key == 'csv') {
      this.exportItems();
    }
  }

  // Método para exportar elementos
  exportItems() {

    this.spinner.show();
    this.reservationService.listForCsv(this.sorts, this.filters).subscribe({
      next: data => {
        if (data.data) {
          // Define the headers for the CSV file
          const headers = ['ID', 'MATRÍCULA', 'FECHA CITA', 'HORA', 'TELÉFONO', 'EMAIL', 'SERVICIO', 'TIPO VEHÍCULO', 'ESTACIÓN', 'MÉTODO DE PAGO', 'ESTADO', 'OPERADOR', 'PROFESIONAL', 'FECHA CREACIÓN'];

          // Create an array to hold each line of the CSV
          const csvData = [];

          // Add the headers as the first line
          csvData.push(headers.join(';'));


          // Iterate over each reservation to generate the CSV rows
          data.data.forEach(item => {
            const row = [
              item.id,
              item.registration_number,
              this.formatDate(item.date, false), // Assuming you have a method to format dates
              item.hour.hour,
              item.phone,
              item.email ? item.email : '',
              item.service?.name,
              item.vehicle?.name,
              item.station?.name,
              item.payment_method?.name,
              item.state ? 'Pasada' : 'No pasada',
              item.user ? item.user.name : '',
              item.professional ? item.professional.name : '',
              this.formatDate(item.created_at, true),
            ];

            // Join each row's data with commas and add to the CSV data array
            csvData.push(row.join(';'));
          });

          // Create a single string with line breaks
          const csvContent = csvData.join('\n');

          this.spinner.hide();

          // Create a Blob from the string and generate a download link
          const bom = '\uFEFF'; // Marca de orden de bytes para UTF-8
          const blob = new Blob([bom + csvContent], { type: 'text/csv;charset=utf-8;' });
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'reservas.csv';
          document.body.appendChild(a);
          a.click();

          // Clean up the DOM
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
        }
        this.loading = false;
      },
      error: err => {
        this.spinner.hide();
        this.loading = false;
      },
    })

  }

  // Helper method to format dates to 'dd/MM/Y'
  formatDate(date: Date | string | undefined, hour: boolean): string {
    if (!date) return '';
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const year = d.getFullYear();
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');

    if (hour) {
      return `${day}/${month}/${year} ${hours}:${minutes}`;
    }
    return `${day}/${month}/${year}`;
  }

  loadFiltersFromInfoDayModal() {
    if (this.router.url.includes('agenda-diaria')) {
      const filters = localStorage.getItem('itv_reservation_filters');

      if (filters) {
        try {
          const parsedFilters = JSON.parse(filters) as ActiveFilter[];

          if (Array.isArray(parsedFilters)) {
            this.filters = parsedFilters.map(filter => {
              if (filter.column === 'date' && Array.isArray(filter.value)) {
                return {
                  ...filter,
                  value: filter.value.map((v: any) => {
                    // Convertir las cadenas ISO a objetos Date
                    if (typeof v === 'string') {
                      return new Date(v);
                    }
                    return v;
                  })
                };
              }
              return filter;
            }); 
            
          }
        } catch (error) {
          console.error('Error al parsear los filtros desde localStorage:', error);
        }
      }
    }
  }

}
